import { PromotionalGraphicProps } from '../components/Graphics/PromotionalGraphic'
// Sample author books data
export const sampleAuthorBooks = [
  {
    id: '1',
    title: 'The Silent Echo',
    author: 'Elena Richards',
    coverImage:
      'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 4.7,
    formats: ['paperback', 'ebook', 'audiobook'],
    genres: ['Mystery', 'Thriller'],
    isNew: true,
    heatLevel: 3,
    darknessLevel: 4,
    endingType: 'HEA',
    characterRelationships: [
      {
        type: 'Enemies to Lovers',
        style: ['Male & Female (MF)', 'Slow Burn'],
      },
    ],
  },
  {
    id: '2',
    title: 'Whispers in the Dark',
    author: 'Elena Richards',
    coverImage:
      'https://images.unsplash.com/photo-1621351183012-e2f9972dd9bf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 4.8,
    formats: ['paperback', 'ebook'],
    genres: ['Horror', 'Supernatural'],
    heatLevel: 2,
    darknessLevel: 5,
    endingType: 'Bittersweet',
    characterRelationships: [
      {
        type: 'Forbidden Love',
        style: ['Male & Female (MF)'],
      },
    ],
  },
]
export const samplePromotionalGraphics: PromotionalGraphicProps[] = [
  {
    id: '1',
    type: 'tropes',
    title: 'The Silent Echo - Tropes',
    description: 'Key tropes featured in The Silent Echo',
    authorId: 'elena-richards',
    authorName: 'Elena Richards',
    bookId: '1',
    bookTitle: 'The Silent Echo',
    imageUrl:
      'https://images.unsplash.com/photo-1516414447565-b14be0adf13e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    tags: ['tropes', 'enemies to lovers', 'small town', 'mystery'],
    downloadUrl: '#',
    shareUrl: '#',
    dateCreated: '2023-04-15',
    // The author promoting their own book — a direct commercial interest.
    uploaderRole: 'author',
    uploaderName: 'Elena Richards',
    disclosures: ['own-business'],
  },
  {
    id: '2',
    type: 'spice level',
    title: 'Whispers in the Dark - Spice Level',
    description: 'Spice level guide for Whispers in the Dark',
    authorId: 'elena-richards',
    authorName: 'Elena Richards',
    bookId: '2',
    bookTitle: 'Whispers in the Dark',
    imageUrl:
      'https://images.unsplash.com/photo-1621351183012-e2f9972dd9bf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    tags: ['spice level', 'medium heat', 'romance'],
    // A PR professional paid by a client. Legitimate work, disclosed, and
    // ranked exactly like any other post.
    uploaderRole: 'pr-professional',
    uploaderName: 'Harper & Vale PR',
    disclosures: ['paid-partnership'],
    downloadUrl: '#',
    shareUrl: '#',
    dateCreated: '2023-05-22',
  },
  {
    id: '3',
    type: 'characters',
    title: 'The Silent Echo - Character Dynamics',
    description: 'Character relationship map for The Silent Echo',
    authorId: 'elena-richards',
    authorName: 'Elena Richards',
    bookId: '1',
    bookTitle: 'The Silent Echo',
    imageUrl:
      'https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    tags: ['characters', 'relationships', 'dynamic'],
    downloadUrl: '#',
    shareUrl: '#',
    dateCreated: '2023-04-18',
  },
  {
    id: '4',
    type: 'aesthetics',
    title: 'Whispers in the Dark - Aesthetic',
    description: 'Visual aesthetic for Whispers in the Dark',
    authorId: 'elena-richards',
    authorName: 'Elena Richards',
    bookId: '2',
    bookTitle: 'Whispers in the Dark',
    imageUrl:
      'https://images.unsplash.com/photo-1518893494013-481c1d8ed3fd?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    tags: ['aesthetics', 'dark', 'moody', 'supernatural'],
    downloadUrl: '#',
    shareUrl: '#',
    dateCreated: '2023-05-30',
  },
  {
    id: '5',
    type: 'themes',
    title: 'The Silent Echo - Themes',
    description: 'Major themes explored in The Silent Echo',
    authorId: 'elena-richards',
    authorName: 'Elena Richards',
    bookId: '1',
    bookTitle: 'The Silent Echo',
    imageUrl:
      'https://images.unsplash.com/photo-1519791883288-dc8bd696e667?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    tags: ['themes', 'betrayal', 'redemption', 'justice'],
    downloadUrl: '#',
    shareUrl: '#',
    dateCreated: '2023-04-25',
  },
  {
    id: '6',
    type: 'tropes',
    title: 'Whispers in the Dark - Tropes',
    description: 'Key tropes featured in Whispers in the Dark',
    authorId: 'elena-richards',
    authorName: 'Elena Richards',
    bookId: '2',
    bookTitle: 'Whispers in the Dark',
    imageUrl:
      'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    tags: ['tropes', 'forbidden love', 'supernatural', 'mystery'],
    downloadUrl: '#',
    shareUrl: '#',
    dateCreated: '2023-06-05',
  },
  {
    id: '7',
    type: 'spice level',
    title: 'The Silent Echo - Spice Level',
    description: 'Spice level guide for The Silent Echo',
    authorId: 'elena-richards',
    authorName: 'Elena Richards',
    bookId: '1',
    bookTitle: 'The Silent Echo',
    imageUrl:
      'https://images.unsplash.com/photo-1634128221889-82ed6efebfc3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    tags: ['spice level', 'medium heat', 'romance'],
    downloadUrl: '#',
    shareUrl: '#',
    dateCreated: '2023-04-20',
  },
  {
    id: '8',
    type: 'content warnings',
    title: 'Whispers in the Dark - Content Warnings',
    description: 'Content warnings for Whispers in the Dark',
    authorId: 'elena-richards',
    authorName: 'Elena Richards',
    bookId: '2',
    bookTitle: 'Whispers in the Dark',
    imageUrl:
      'https://images.unsplash.com/photo-1621528934522-b0d36db15b43?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    tags: ['content warnings', 'violence', 'dark themes'],
    downloadUrl: '#',
    shareUrl: '#',
    dateCreated: '2023-06-10',
  },
  {
    id: '9',
    type: 'aesthetics',
    title: 'The Silent Echo - Aesthetic',
    description: 'Visual aesthetic for The Silent Echo',
    authorId: 'elena-richards',
    authorName: 'Elena Richards',
    bookId: '1',
    bookTitle: 'The Silent Echo',
    imageUrl:
      'https://images.unsplash.com/photo-1512850183-6d7990f42385?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    tags: ['aesthetics', 'mystery', 'thriller', 'small town'],
    downloadUrl: '#',
    shareUrl: '#',
    dateCreated: '2023-04-30',
  },
  {
    id: '10',
    type: 'characters',
    title: 'Whispers in the Dark - Character Dynamics',
    description: 'Character relationship map for Whispers in the Dark',
    authorId: 'elena-richards',
    authorName: 'Elena Richards',
    bookId: '2',
    bookTitle: 'Whispers in the Dark',
    imageUrl:
      'https://images.unsplash.com/photo-1517673400267-0251440c45dc?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    tags: ['characters', 'relationships', 'dynamic'],
    downloadUrl: '#',
    shareUrl: '#',
    dateCreated: '2023-06-15',
  },
  {
    id: '11',
    type: 'quote',
    title: 'The Silent Echo - Favorite Quote',
    description: 'A memorable quote from The Silent Echo',
    authorId: 'elena-richards',
    authorName: 'Elena Richards',
    bookId: '1',
    bookTitle: 'The Silent Echo',
    imageUrl:
      'https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    tags: ['quote', 'inspirational'],
    downloadUrl: '#',
    shareUrl: '#',
    dateCreated: '2023-05-05',
  },
  {
    id: '12',
    type: 'quote',
    title: 'Whispers in the Dark - Favorite Quote',
    description: 'A memorable quote from Whispers in the Dark',
    authorId: 'elena-richards',
    authorName: 'Elena Richards',
    bookId: '2',
    bookTitle: 'Whispers in the Dark',
    imageUrl:
      'https://images.unsplash.com/photo-1518002171953-a080ee817e1f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    tags: ['quote', 'dark', 'mysterious'],
    downloadUrl: '#',
    shareUrl: '#',
    dateCreated: '2023-06-20',
  },
]
